import VueRouter from 'vue-router'
import Vuex from 'vuex'
import Ls from './services/ls'
import store from './store/index.js'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VDropdown from './components/dropdown/VDropdown.vue'
import VDropdownItem from './components/dropdown/VDropdownItem.vue'
import VDropdownDivider from './components/dropdown/VDropdownDivider.vue'
import DotIcon from './components/icon/DotIcon.vue'
import CustomerModal from './components/base/modal/CustomerModal.vue'
import TaxTypeModal from './components/base/modal/TaxTypeModal.vue'
import CategoryModal from './components/base/modal/CategoryModal.vue'
import money from 'v-money'
import VTooltip from 'v-tooltip'
import CKEditor from 'ckeditor4-vue'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
/**
 * Global css plugins
 */
import 'vue-tabs-component/docs/resources/tabs-component.css'
import VueCountdownTimer from 'vuejs-countdown-timer'

Vue.use(Vuelidate)
Vue.use(CKEditor)
window._ = require('lodash')
/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue')

/**
 * Font Awesome
 */
require('../plugins/vue-font-awesome/index')

/**
 * Custom Directives
 */
require('./helpers/directives')

/**
 * Base Components
 */
require('./components/base')

/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.
 */

window.axios = require('axios')
window.Ls = Ls
global.$ = global.jQuery = require('jquery')

window.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
}

/**
 * Interceptors
 */

window.axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  const AUTH_TOKEN = Ls.get('auth.token')
  const companyId = Ls.get('selectedCompany')

  // Don't send Authorization header for login/register/password-reset/OTP routes
  const publicRoutes = [
    '/api/auth/login',
    '/api/auth/register',
    '/api/auth/verifyOtp',
    '/api/auth/resendOtp',
    '/api/auth/password/email',
    '/api/auth/reset/password',
    '/api/is-registered'
  ]
  const isPublicRoute = publicRoutes.some(route => config.url && config.url.includes(route))

  if (AUTH_TOKEN && !isPublicRoute) {
    config.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`
  }

  if (companyId) {
    config.headers.common['company'] = companyId
  }

  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

/**
 * Global Axios Response Interceptor
 */

global.axios.interceptors.response.use(undefined, function (err) {
  // Do something with request error

  // Handle Zoho OAuth requirement globally: same-tab redirect
  if (err && err.response && err.response.status === 409) {
    const data = err.response.data || {}
    if (data.message === 'authorization_required' && data.redirect_to) {
      window.location.assign(data.redirect_to)
      // Prevent further error handling, navigation will occur
      return new Promise(() => {})
    }
  }

  if (err.response.status === 403) {
    window.toastr['error'](err.response.data.message)
    store.dispatch('auth/logout', true)
  }
  if (!err.response) {
    window.toastr['error']('Network error: Please check your internet connection or wait until servers are back online')
  } else {
    if (err.response.data && (err.response.statusText === 'Unauthorized' || err.response.data === ' Unauthorized.')) {
      // Unauthorized and log out
      window.toastr['error']((err.response.data.message) ? err.response.data.message : 'Unauthorized')
      store.dispatch('auth/logout', true)
    } else {
      // Unknown error

      const errors = JSON.parse(JSON.stringify(err.response.data))
      if (Object.keys(errors).length > 0) {
        window.toastr['error']('Request Timeout Error')
      } else {
        window.toastr['error']((err.response.data.message) ? err.response.data.message : 'Unknown error occurred')
      }
    }
  }
  return Promise.reject(err)
})

/**
 * Global plugins
 */
window.toastr = require('toastr')
Vue.use(VueCountdownTimer)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VTooltip)

// register directive v-money and component <money>
Vue.use(money, {precision: 2})
Vue.component('datetime', Datetime)
Vue.component('v-dropdown', VDropdown)
Vue.component('v-dropdown-item', VDropdownItem)
Vue.component('v-dropdown-divider', VDropdownDivider)

Vue.component('dot-icon', DotIcon)
Vue.component('customer-modal', CustomerModal)
Vue.component('tax-type-modal', TaxTypeModal)
Vue.component('category-modal', CategoryModal)
